<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Notes"
              icon="fas fa-list">
            </card-section-header>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12">
                  <p-table [value]="siteNotes" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Note</th>
                        <th>User</th>
                        <th>Work Order / Asset</th>
                        <th>Date (last updated)</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-note>
                      <tr *ngIf="note.notes">
                        <td>{{note.notes}}</td>
                        <td>{{note.user.firstName}} {{note.user.lastName}} ({{note.user.login}})</td>
                        <td>
                          <span *ngIf="note.siteSession.workOrder === null">
                            <span class="badge badge-pill badge-primary">Site Session</span>
                          </span>
                          <span *ngIf="note.siteSession.workOrder !== null">
                            WRK{{note.siteSession.workOrder.id}} / {{note.siteSession.workOrder.asset.name}}
                          </span>
                        </td>
                        <td>{{note.notesLastUpdated | date: 'medium' }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="4">
                          No notes found
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
